import { render, staticRenderFns } from "./TheSourceBadge.vue?vue&type=template&id=6e0b5446&scoped=true&"
import script from "./TheSourceBadge.vue?vue&type=script&lang=js&"
export * from "./TheSourceBadge.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceBadge.vue?vue&type=style&index=0&id=6e0b5446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b5446",
  null
  
)

export default component.exports